/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconClose8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M1.168 1.168a.572.572 0 0 0 0 .809L3.19 4 1.168 6.023a.572.572 0 0 0 .809.81L4 4.808l2.023 2.023a.572.572 0 0 0 .81-.809L4.808 4l2.023-2.023a.572.572 0 0 0-.809-.81L4 3.192 1.977 1.168a.572.572 0 0 0-.81 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M2.223 2.223a.763.763 0 0 0 0 1.08L4.921 6 2.223 8.698a.763.763 0 0 0 1.08 1.079L6 7.079l2.698 2.698a.763.763 0 1 0 1.079-1.08L7.079 6l2.698-2.698a.763.763 0 1 0-1.08-1.079L6 4.921 3.302 2.223a.763.763 0 0 0-1.079 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M2.793 2.793a1 1 0 0 0 0 1.414L6.586 8l-3.793 3.793a1 1 0 1 0 1.414 1.414L8 9.414l3.793 3.793a1 1 0 0 0 1.414-1.414L9.414 8l3.793-3.793a1 1 0 0 0-1.414-1.414L8 6.586 4.207 2.793a1 1 0 0 0-1.414 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M17.207 4.207a1 1 0 0 0-1.414-1.414L10 8.586 4.207 2.793a1 1 0 0 0-1.414 1.414L8.586 10l-5.793 5.793a1 1 0 1 0 1.414 1.414L10 11.414l5.793 5.793a1 1 0 0 0 1.414-1.414L11.414 10l5.793-5.793Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconClose = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconClose8 {...iconProps} />;
        case '12':
            return <IconClose12 {...iconProps} />;
        case '16':
            return <IconClose16 {...iconProps} />;
        case '20':
            return <IconClose20 {...iconProps} />;
        case '24':
            return <IconClose24 {...iconProps} />;
        default:
            return <IconClose24 {...iconProps} />;
    }
});
